import { render, staticRenderFns } from "./GeoLocation.vue?vue&type=template&id=54c0aff2&scoped=true"
import script from "./GeoLocation.vue?vue&type=script&lang=js"
export * from "./GeoLocation.vue?vue&type=script&lang=js"
import style0 from "./styles/geo-location.css?vue&type=style&index=0&id=54c0aff2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c0aff2",
  null
  
)

export default component.exports